/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const ALL_TYPE = 'Type (All)';

const initialState = {
  isSidebarCollapsed: false,
  isOpen: true,
  projectOverviewListProjectEnableListView: false,
  isProjectCreatedFromAppBar: false,
  projectOverviewRegulationFilter: 'All',
  projectOveriewProjectTypeFilter: ALL_TYPE,
  createEditUdfTypeFilter: 'Type',
  projectOverviewProjectSearch: '',
  modelManagerListEnableListView: false,
  modelManagerModelSearch: '',
  modelManagerModelTypeFilter: ALL_TYPE,
  modelManagerModelStatusFilter: ALL_TYPE,
  modelManagerModelFilter: ALL_TYPE,
  documentTypeFilter: ALL_TYPE,
  pipelineListProjectEnableListView: false,
  createEditUdfArgumentsEnableListView: false,
  pipelineProjectSearch: '',
  pipelineProjectCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  usersCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  usersNameSearch: '',
  modelNameSearch: '',
  relatedJobsSearch: '',
  relatedPipelinesSearch: '',
  modelDocumentSearch: '',
  linkedProjectSearch: '',
  modelRelatedUDFSearch: '',
  selectedModel: [],
  groupsCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  groupsNameSearch: '',
  accessLogsCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  consoleFileNameSearch: '',
  auditLogsCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  auditLogsNameSearch: '',
  accessLogsNameSearch: '',
  datasetsNameSearch: '',
  datasetsFilterByProject: {
    value: 'all',
    label: 'All project',
  },
  documentationNameSearch: '',
  documentationProjectTypeFilter: 'all',
  documentationCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  documentationProjectListFilter: {
    value: 'all',
    label: 'All project',
  },
  documentationListProjectEnableListView: true,
  newDocumentationNameSearch: '',
  templateNameSearch: '',
  newDocumentationProjectTypeFilter: 'all',
  newDocumentationCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  templateCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  newDocumentationProjectListFilter: {
    value: 'all',
    label: 'All project',
  },
  newDocumentationListProjectEnableListView: false,
  templateListProjectEnableListView: false,
  dataManagementProjectListNameSearch: '',
  dataManagementDatasetListNameSearch: '',
  workerListEnableListView: false,
  pipelineExecutionHistoryPipelineNameSearch: '',
  pipelineExecutionHistoryCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  pipelineExecutionHistoryEnableListView: false,
  consoleLibraryNameSearch: '',
  integrationAPITokenSearch: '',
  integrationAPITokenCreatedOnFilter: {
    fromDate: null,
    toDate: null,
  },
  selectedExecutionIdsForComparison: [],
  udfManagerUdfSearch: '',
  helpDocumentKeywordSearch: null,
  helpDrawerKeywordSearch: null,
  triggerThemeChange: false,
  triggerHeaderIconChange: false,
  triggerProductIconChange: false,
  lockedArtifacts: [],
  currentlyLockedArtifact: {},
  lastProjectStatus: {},
  taskManagerTaskStatusFilter: 'All Status',
  taskManagerTaskTypeFilter: 'All Task Type',
  taskManagerModelIdFilter: 'All Models',
  taskManagerPipelineSearch: '',
  taskManagerResultSearch: '',
  taskManagerDocumentSearch: '',
  taskManagerSearch: '',
  modelManagerTaskStatusFilter: 'All Status',
  modelManagerTaskTypeFilter: 'All Task Type',
  modelManagerTaskSearch: '',
  myTaskManagerTaskStatusFilter: 'All Status',
  myTaskManagerTaskTypeFilter: 'All Task Type',
  myTaskManagerModelIdFilter: 'All Models',
  myTaskManagerSearch: '',
  modelsFilterByProject: {
    project_id: -1,
    name: 'My models',
  },
  udfsFilterByProject: {
    project_id: null,
    name: null,
  },
  jobsFilterByProject: {
    project_id: null,
    name: null,
  },
  pipelinesFilterByProject: {
    project_id: null,
    name: null,
  },
  tasksFilterByProject: {
    project_id: null,
    name: null,
  },
  modelManagerTaskDocumentTaskFilter: -1,
  unseenNotificationCount: 0,
};

/**
 * @function commonSlice  Common slice reducer.
 * @description Redux slice reducer for common/shared state.
 * @param {initialState} state - Current common state.
 * @param {string} name - Name of the action.
 * @returns {object} commonSlice reducer.
 */
export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setIsProjectCreatedFromAppBar: (state, action) => {
      state.isProjectCreatedFromAppBar = action.payload;
    },
    toggleSidebarWidth: (state) => {
      state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
    toggleProjectOverviewProjectListView: (state) => {
      state.projectOverviewListProjectEnableListView =
        !state.projectOverviewListProjectEnableListView;
    },
    toggleCreateEditUdfArgumentsEnableListView: (state) => {
      state.createEditUdfArgumentsEnableListView =
        !state.createEditUdfArgumentsEnableListView;
    },
    setProjectOverviewRegulationFilter: (state, action) => {
      state.projectOverviewRegulationFilter = action.payload
        ? action.payload
        : initialState.projectOverviewRegulationFilter;
    },
    setCreateEditUdfTypeFilter: (state, action) => {
      state.createEditUdfTypeFilter = action.payload
        ? action.payload
        : initialState.createEditUdfTypeFilter;
    },
    setProjectOverviewProjectTypeFilter: (state, action) => {
      state.projectOveriewProjectTypeFilter = action.payload
        ? action.payload
        : initialState.projectOveriewProjectTypeFilter;
    },
    setProjectOverviewProjectSearch: (state, action) => {
      state.projectOverviewProjectSearch = action.payload;
    },
    toggleModelManagerListView: (state) => {
      state.modelManagerListEnableListView =
        !state.modelManagerListEnableListView;
    },
    setModelManagerModelSearch: (state, action) => {
      state.modelManagerModelSearch = action.payload;
    },
    setModelManagerModelTypeFilter: (state, action) => {
      state.modelManagerModelTypeFilter = action.payload
        ? action.payload
        : initialState.modelManagerModelTypeFilter;
    },
    setModelManagerModelStatusFilter: (state, action) => {
      state.modelManagerModelStatusFilter = action.payload
        ? action.payload
        : initialState.modelManagerModelStatusFilter;
    },
    setModelManagerModelFilter: (state, action) => {
      state.modelManagerModelFilter = action.payload
        ? action.payload
        : initialState.modelManagerModelFilter;
    },
    setDocumentTypeFilter: (state, action) => {
      state.documentTypeFilter = action.payload
        ? action.payload
        : initialState.documentTypeFilter;
    },
    setSelectedModel: (state, action) => {
      state.selectedModel = action.payload
        ? action.payload
        : initialState.selectedModel;
    },
    setUdfManagerUdfSearch: (state, action) => {
      state.udfManagerUdfSearch = action.payload;
    },
    togglePipelineProjectListView: (state) => {
      state.pipelineListProjectEnableListView =
        !state.pipelineListProjectEnableListView;
    },
    setPipelineProjectSearch: (state, action) => {
      state.pipelineProjectSearch = action.payload;
    },
    setPipelineProjectCreatedOnFilter: (state, action) => {
      state.pipelineProjectCreatedOnFilter = action.payload
        ? action.payload
        : initialState.pipelineProjectCreatedOnFilter;
    },
    setUsersNameSearch: (state, action) => {
      state.usersNameSearch = action.payload;
    },
    setConsoleFileNameSearch: (state, action) => {
      state.consoleFileNameSearch = action.payload;
    },
    setModelNameSearch: (state, action) => {
      state.modelNameSearch = action.payload;
    },
    setRelatedJobsSearch: (state, action) => {
      state.relatedJobsSearch = action.payload;
    },
    setRelatedPipelinesSearch: (state, action) => {
      state.relatedPipelinesSearch = action.payload;
    },
    setModelDocumentSearch: (state, action) => {
      state.modelDocumentSearch = action.payload;
    },
    setModelRelatedUDFSearch: (state, action) => {
      state.modelRelatedUDFSearch = action.payload;
    },
    setHelpDocumentKeywordSearch: (state, action) => {
      state.helpDocumentKeywordSearch = action.payload;
    },
    setHelpDrawerKeywordSearch: (state, action) => {
      state.helpDrawerKeywordSearch = action.payload;
    },
    setUsersCreatedOnFilter: (state, action) => {
      state.usersCreatedOnFilter = action.payload
        ? action.payload
        : initialState.usersCreatedOnFilter;
    },
    setGroupsNameSearch: (state, action) => {
      state.groupsNameSearch = action.payload;
    },
    setGroupsCreatedOnFilter: (state, action) => {
      state.groupsCreatedOnFilter = action.payload
        ? action.payload
        : initialState.groupsCreatedOnFilter;
    },
    setAccessLogsNameSearch: (state, action) => {
      state.accessLogsNameSearch = action.payload;
    },
    setAccessLogsCreatedOnFilter: (state, action) => {
      state.accessLogsCreatedOnFilter = action.payload
        ? action.payload
        : initialState.accessLogsCreatedOnFilter;
    },
    setAuditLogsNameSearch: (state, action) => {
      state.auditLogsNameSearch = action.payload;
    },
    setAuditLogsCreatedOnFilter: (state, action) => {
      state.auditLogsCreatedOnFilter = action.payload
        ? action.payload
        : initialState.auditLogsCreatedOnFilter;
    },
    setDatasetsNameSearch: (state, action) => {
      state.datasetsNameSearch = action.payload;
    },
    setDatasetsFilterByProject: (state, action) => {
      state.datasetsFilterByProject = action.payload
        ? action.payload
        : initialState.datasetsFilterByProject;
    },
    setDocumentationProjectTypeFilter: (state, action) => {
      state.documentationProjectTypeFilter = action.payload
        ? action.payload
        : initialState.documentationProjectTypeFilter;
    },
    setDocumentationCreatedOnFilter: (state, action) => {
      state.documentationCreatedOnFilter = action.payload
        ? action.payload
        : initialState.documentationCreatedOnFilter;
    },
    setDocumentationProjectListFilter: (state, action) => {
      state.documentationProjectListFilter = action.payload
        ? action.payload
        : initialState.documentationProjectListFilter;
    },
    toggleDocumentationProjectListView: (state) => {
      state.documentationListProjectEnableListView =
        !state.documentationListProjectEnableListView;
    },
    setDocumentationNameSearch: (state, action) => {
      state.documentationNameSearch = action.payload;
    },
    setNewDocumentationProjectTypeFilter: (state, action) => {
      state.newDocumentationProjectTypeFilter = action.payload
        ? action.payload
        : initialState.newDocumentationProjectTypeFilter;
    },
    setNewDocumentationCreatedOnFilter: (state, action) => {
      state.newDocumentationCreatedOnFilter = action.payload
        ? action.payload
        : initialState.newDocumentationCreatedOnFilter;
    },
    setTemplateCreatedOnFilter: (state, action) => {
      state.templateCreatedOnFilter = action.payload
        ? action.payload
        : initialState.templateCreatedOnFilter;
    },
    setNewDocumentationProjectListFilter: (state, action) => {
      state.newDocumentationProjectListFilter = action.payload
        ? action.payload
        : initialState.newDocumentationProjectListFilter;
    },
    toggleNewDocumentationProjectListView: (state) => {
      state.newDocumentationListProjectEnableListView =
        !state.newDocumentationListProjectEnableListView;
    },
    toggleTemplateProjectListView: (state) => {
      state.templateListProjectEnableListView =
        !state.templateListProjectEnableListView;
    },
    setNewDocumentationNameSearch: (state, action) => {
      state.newDocumentationNameSearch = action.payload;
    },
    setTemplateNameSearch: (state, action) => {
      state.templateNameSearch = action.payload;
    },
    setDataManagementProjectListNameSearch: (state, action) => {
      state.dataManagementProjectListNameSearch = action.payload;
    },
    setDataManagementDatasetListNameSearch: (state, action) => {
      state.dataManagementDatasetListNameSearch = action.payload;
    },
    toggleWorkerListView: (state) => {
      state.workerListEnableListView = !state.workerListEnableListView;
    },
    setPipelineExecutionHistoryPipelineNameSearch: (state, action) => {
      state.pipelineExecutionHistoryPipelineNameSearch = action.payload;
    },
    setPipelineExecutionHistoryCreatedOnFilter: (state, action) => {
      state.pipelineExecutionHistoryCreatedOnFilter = action.payload
        ? action.payload
        : initialState.pipelineExecutionHistoryCreatedOnFilter;
    },
    togglePipelineExecutionHistoryPipelineListView: (state) => {
      state.pipelineExecutionHistoryEnableListView =
        !state.pipelineExecutionHistoryEnableListView;
    },
    setConsoleLibraryNameSearch: (state, action) => {
      state.consoleLibraryNameSearch = action.payload;
    },
    setIntegrationAPITokenSearch: (state, action) => {
      state.integrationAPITokenSearch = action.payload;
    },
    setIntegrationAPITokenCreatedOnFilter: (state, action) => {
      state.integrationAPITokenCreatedOnFilter = action.payload
        ? action.payload
        : initialState.integrationAPITokenCreatedOnFilter;
    },
    setSelectedExecutionIdsForComparison: (state, action) => {
      state.selectedExecutionIdsForComparison = action.payload;
    },
    setTriggerThemeChange: (state) => {
      state.triggerThemeChange = !state.triggerThemeChange;
    },
    setTriggerProductIconChange: (state) => {
      state.triggerProductIconChange = !state.triggerProductIconChange;
    },
    setTriggerHeaderIconChange: (state) => {
      state.triggerHeaderIconChange = !state.triggerHeaderIconChange;
    },
    setLockedArtifacts: (state, action) => {
      state.lockedArtifacts = action.payload;
    },
    setCurrentlyLockedArtifact: (state, action) => {
      state.currentlyLockedArtifact = action.payload;
    },
    setLastProjetStatus: (state, action) => {
      state.lastProjectStatus = action.payload;
    },
    setTaskManagerTaskStatusFilter: (state, action) => {
      state.taskManagerTaskStatusFilter = action.payload
        ? action.payload
        : initialState.taskManagerTaskStatusFilter;
    },
    setTaskManagerModelIdFilter: (state, action) => {
      state.taskManagerModelIdFilter = action.payload
        ? action.payload
        : initialState.taskManagerModelIdFilter;
    },
    setTaskManagerPipelineSearch: (state, action) => {
      state.taskManagerPipelineSearch = action.payload;
    },
    setTaskManagerSearch: (state, action) => {
      state.taskManagerSearch = action.payload;
    },
    setTaskManagerDocumentSearch: (state, action) => {
      state.taskManagerDocumentSearch = action.payload;
    },
    setTaskManagerTaskTypeFilter: (state, action) => {
      state.taskManagerTaskTypeFilter = action.payload;
    },
    setTaskManagerResultSearch: (state, action) => {
      state.taskManagerResultSearch = action.payload;
    },
    setModelManagerTaskStatusFilter: (state, action) => {
      state.modelManagerTaskStatusFilter = action.payload
        ? action.payload
        : initialState.modelManagerTaskStatusFilter;
    },
    setModelManagerTaskTypeFilter: (state, action) => {
      state.modelManagerTaskTypeFilter = action.payload
        ? action.payload
        : initialState.modelManagerTaskTypeFilter;
    },
    setModelManagerTaskSearch: (state, action) => {
      state.modelManagerTaskSearch = action.payload;
    },
    setMyTaskManagerTaskStatusFilter: (state, action) => {
      state.myTaskManagerTaskStatusFilter = action.payload;
    },
    setMyTaskManagerModelIdFilter: (state, action) => {
      state.myTaskManagerModelIdFilter = action.payload;
    },
    setMyTaskManagerSearch: (state, action) => {
      state.myTaskManagerSearch = action.payload;
    },
    setMyTaskManagerTaskTypeFilter: (state, action) => {
      state.myTaskManagerTaskTypeFilter = action.payload;
    },
    setModelsFilterByProject: (state, action) => {
      state.modelsFilterByProject = action.payload
        ? action.payload
        : initialState.modelsFilterByProject;
    },
    setUdfsFilterByProject: (state, action) => {
      state.udfsFilterByProject = action.payload
        ? action.payload
        : initialState.udfsFilterByProject;
    },
    setJobsFilterByProject: (state, action) => {
      state.jobsFilterByProject = action.payload
        ? action.payload
        : initialState.jobsFilterByProject;
    },
    setPipelinesFilterByProject: (state, action) => {
      state.pipelinesFilterByProject = action.payload
        ? action.payload
        : initialState.pipelinesFilterByProject;
    },
    setTasksFilterByProject: (state, action) => {
      state.tasksFilterByProject = action.payload
        ? action.payload
        : initialState.tasksFilterByProject;
    },

    setModelManagerTaskDocumentTaskFilter: (state, action) => {
      state.modelManagerTaskDocumentTaskFilter = action.payload
        ? action.payload
        : initialState.modelManagerTaskDocumentTaskFilter;
    },
    setLinkedProjectSearch: (state, action) => {
      state.linkedProjectSearch = action.payload
        ? action.payload
        : initialState.linkedProjectSearch;
    },
    setUnseenNotificationCount: (state, action) => {
      state.unseenNotificationCount = action.payload
        ? action.payload
        : initialState.unseenNotificationCount;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  toggleSidebarWidth,
  toggleProjectOverviewProjectListView,
  toggleCreateEditUdfArgumentsEnableListView,
  setCreateEditUdfTypeFilter,
  setProjectOverviewRegulationFilter,
  setProjectOverviewProjectTypeFilter,
  setProjectOverviewProjectSearch,
  toggleModelManagerListView,
  setModelManagerModelSearch,
  setModelManagerModelTypeFilter,
  setModelManagerModelStatusFilter,
  setModelManagerModelFilter,
  setDocumentTypeFilter,
  togglePipelineProjectListView,
  setPipelineProjectCreatedOnFilter,
  setPipelineProjectSearch,
  setUsersNameSearch,
  setModelNameSearch,
  setUdfManagerUdfSearch,
  setRelatedJobsSearch,
  setRelatedPipelinesSearch,
  setModelDocumentSearch,
  setModelRelatedUDFSearch,
  setSelectedModel,
  setHelpDocumentKeywordSearch,
  setHelpDrawerKeywordSearch,
  setUsersCreatedOnFilter,
  setGroupsNameSearch,
  setGroupsCreatedOnFilter,
  setDocumentationCreatedOnFilter,
  setDocumentationProjectListFilter,
  setDocumentationProjectTypeFilter,
  toggleDocumentationProjectListView,
  setDocumentationNameSearch,
  setNewDocumentationCreatedOnFilter,
  setTemplateCreatedOnFilter,
  setNewDocumentationProjectListFilter,
  setNewDocumentationProjectTypeFilter,
  toggleNewDocumentationProjectListView,
  toggleTemplateProjectListView,
  setNewDocumentationNameSearch,
  setTemplateNameSearch,
  setDataManagementDatasetListNameSearch,
  setDataManagementProjectListNameSearch,
  toggleWorkerListView,
  setPipelineExecutionHistoryPipelineNameSearch,
  setPipelineExecutionHistoryCreatedOnFilter,
  togglePipelineExecutionHistoryPipelineListView,
  setDatasetsNameSearch,
  setDatasetsFilterByProject,
  setConsoleLibraryNameSearch,
  setIntegrationAPITokenSearch,
  setIntegrationAPITokenCreatedOnFilter,
  setAccessLogsNameSearch,
  setAccessLogsCreatedOnFilter,
  setConsoleFileNameSearch,
  setAuditLogsCreatedOnFilter,
  setAuditLogsNameSearch,
  setSelectedExecutionIdsForComparison,
  setTriggerThemeChange,
  setTriggerProductIconChange,
  setTriggerHeaderIconChange,
  setLockedArtifacts,
  setCurrentlyLockedArtifact,
  setLastProjetStatus,
  setIsProjectCreatedFromAppBar,
  setTaskManagerTaskStatusFilter,
  setTaskManagerPipelineSearch,
  setTaskManagerDocumentSearch,
  setTaskManagerModelIdFilter,
  setTaskManagerSearch,
  setTaskManagerTaskTypeFilter,
  setTaskManagerResultSearch,
  setModelManagerTaskStatusFilter,
  setModelManagerTaskTypeFilter,
  setModelManagerTaskSearch,
  setMyTaskManagerTaskStatusFilter,
  setMyTaskManagerModelIdFilter,
  setMyTaskManagerSearch,
  setMyTaskManagerTaskTypeFilter,
  setModelsFilterByProject,
  setUdfsFilterByProject,
  setJobsFilterByProject,
  setPipelinesFilterByProject,
  setTasksFilterByProject,
  setModelManagerTaskDocumentTaskFilter,
  setLinkedProjectSearch,
  setUnseenNotificationCount,
} = commonSlice.actions;

/**
 * Default export of the common slice reducer.
 * @type {Function}
 */
export default commonSlice.reducer;
